import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8546964c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brand-container" }
const _hoisted_2 = { class: "row mb-4" }
const _hoisted_3 = { class: "col-md-3 card-brand" }
const _hoisted_4 = { class: "col-md-3 card-brand" }
const _hoisted_5 = { class: "col-md-3 card-brand" }
const _hoisted_6 = { class: "col-md-3 card-brand" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "row mb-4" }
const _hoisted_9 = { class: "col-md-3 card-brand" }
const _hoisted_10 = { class: "col-md-3 card-brand" }
const _hoisted_11 = { class: "col-md-3 card-brand" }
const _hoisted_12 = { class: "col-md-3 card-brand" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardMonthTotals = _resolveComponent("DashboardMonthTotals")!
  const _component_DashboardRealizedBudget = _resolveComponent("DashboardRealizedBudget")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DashboardMonthTotals, {
          salesChannelName: "Wholesale",
          monthTotals: _ctx.monthTotalsWholesale,
          loading: _ctx.loadingMonthTotalsWholesale,
          access: _ctx.accessWholesale
        }, null, 8, ["monthTotals", "loading", "access"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_DashboardMonthTotals, {
          salesChannelName: "DTC",
          monthTotals: _ctx.monthTotalsDtc,
          loading: _ctx.loadingMonthTotalsDtc,
          access: _ctx.accessDtc
        }, null, 8, ["monthTotals", "loading", "access"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_DashboardMonthTotals, {
          salesChannelName: "Exportação",
          monthTotals: _ctx.monthTotalsExport,
          loading: _ctx.loadingMonthTotalsExport,
          access: _ctx.accessExport
        }, null, 8, ["monthTotals", "loading", "access"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_DashboardMonthTotals, {
          salesChannelName: "ECOMM",
          monthTotals: _ctx.monthTotalsEcomm,
          loading: _ctx.loadingMonthTotalsEcomm,
          access: _ctx.accessEcomm
        }, null, 8, ["monthTotals", "loading", "access"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_DashboardRealizedBudget, {
            realizedBudget: _ctx.realizedBudgetWholesale,
            channelName: "WHOLESALE",
            loading: _ctx.loadingRealizedBudgetWholesale,
            access: _ctx.accessWholesale
          }, null, 8, ["realizedBudget", "loading", "access"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_DashboardRealizedBudget, {
            realizedBudget: _ctx.realizedBudgetDtc,
            channelName: "DTC",
            loading: _ctx.loadingRealizedBudgetDtc,
            access: _ctx.accessDtc
          }, null, 8, ["realizedBudget", "loading", "access"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_DashboardRealizedBudget, {
            realizedBudget: _ctx.realizedBudgetExport,
            channelName: "Exportação",
            loading: _ctx.loadingRealizedBudgetExport,
            access: _ctx.accessExport
          }, null, 8, ["realizedBudget", "loading", "access"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_DashboardRealizedBudget, {
            realizedBudget: _ctx.realizedBudgetEcomm,
            channelName: "ECOMM",
            loading: _ctx.loadingRealizedBudgetEcomm,
            access: _ctx.accessEcomm
          }, null, 8, ["realizedBudget", "loading", "access"])
        ])
      ])
    ])
  ]))
}